import React, { useState, useEffect } from 'react';

interface BooleanSliderProps {
  label: string;
  value?: boolean;
  onChange?: (val: boolean) => void;
}

const BooleanSlider: React.FC<BooleanSliderProps> = ({
  label,
  value = false,
  onChange,
}) => {
  const [checked, setChecked] = useState<boolean>(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleToggle = () => {
    const newVal = !checked;
    setChecked(newVal);
    onChange?.(newVal);
  };

  return (
    <div className="form-check form-switch">
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={`switch-${label}`}
        checked={checked}
        onChange={handleToggle}
      />
      <label className="form-check-label" htmlFor={`switch-${label}`}>
        {label}
      </label>
    </div>
  );
};

export default BooleanSlider;